import { Eye, EyeOff, Lock } from "lucide-react";
import { useState } from "react";

export default function ChangePasswordModal({
  open,
  onClose,
  onSubmit,
  loading,
}) {
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [form, setForm] = useState({
    password: "",
    newPassword: "",
    confirmPassword: "",
  });

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-full max-w-md rounded-3xl bg-white p-7 shadow-xl">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Lock className="h-5 w-5 text-slate-900" />
            <h2 className="text-xl font-semibold text-slate-900">
              Change Password
            </h2>
          </div>
        </div>

        <div className="mb-4">
          <label className="mb-2 block text-sm font-medium text-slate-900">
            Current Password
          </label>

          <div className="relative">
            <input
              type={showCurrent ? "text" : "password"}
              value={form.password}
              onChange={(e) =>
                setForm({
                  ...form,
                  password: e.target.value,
                })
              }
              className="h-12 w-full rounded-2xl bg-[#efe5df] px-4 pr-12 text-slate-900 outline-none"
            />

            <button
              type="button"
              onClick={() => setShowCurrent((p) => !p)}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500"
            >
              {showCurrent ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        <div className="mb-4">
          <label className="mb-2 block text-sm font-medium text-slate-900">
            New Password
          </label>

          <div className="relative">
            <input
              type={showNew ? "text" : "password"}
              value={form.newPassword}
              onChange={(e) =>
                setForm({
                  ...form,
                  newPassword: e.target.value,
                })
              }
              className="h-12 w-full rounded-2xl bg-[#efe5df] px-4 pr-12 text-slate-900 outline-none"
            />

            <button
              type="button"
              onClick={() => setShowNew((p) => !p)}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500"
            >
              {showNew ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        <div>
          <label className="mb-2 block text-sm font-medium text-slate-900">
            Confirm Password
          </label>

          <div className="relative">
            <input
              type={showConfirm ? "text" : "password"}
              value={form.confirmPassword}
              onChange={(e) =>
                setForm({
                  ...form,
                  confirmPassword: e.target.value,
                })
              }
              className="h-12 w-full rounded-2xl bg-[#efe5df] px-4 pr-12 text-slate-900 outline-none"
            />

            <button
              type="button"
              onClick={() => setShowConfirm((p) => !p)}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500"
            >
              {showConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        {/* Password Rules */}
        <div className="mt-5 rounded-2xl bg-stone-50 p-4 text-sm text-stone-600">
          <p>Password must contain:</p>

          <div className="mt-2 space-y-1 text-xs ml-2">
            <p
              className={
                /[!@#$%^&*,.?"|]/.test(form.newPassword)
                  ? "text-green-600"
                  : "text-gray-400"
              }
            >
              At least one special character
            </p>

            <p
              className={
                /[A-Z]/.test(form.newPassword)
                  ? "text-green-600"
                  : "text-gray-400"
              }
            >
              At least one uppercase letter
            </p>

            <p
              className={
                /\d/.test(form.newPassword) ? "text-green-600" : "text-gray-400"
              }
            >
              At least one number
            </p>
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="rounded-2xl border border-gray-300 px-5 py-2 font-medium text-slate-900"
          >
            Cancel
          </button>

          <button
            onClick={() => onSubmit(form)}
            disabled={loading}
            className="rounded-2xl bg-slate-900 px-5 py-2 font-medium text-white hover:bg-slate-800"
          >
            {loading ? "Saving..." : "Update Password"}
          </button>
        </div>
      </div>
    </div>
  );
}
